const AUTH_TOKEN_KEY = 'admin_auth_token';
const ADMIN_INFO_KEY = 'admin_info';

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(ADMIN_INFO_KEY);
};

export const getAdminInfo = () => {
  const info = localStorage.getItem(ADMIN_INFO_KEY);
  return info ? JSON.parse(info) : null;
};

export const setAdminInfo = (info) => {
  localStorage.setItem(ADMIN_INFO_KEY, JSON.stringify(info));
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};






